<template>
	<Button state="icon" :size="computedValue.size" :type="computedValue.type" @click="handleClick">
		<Icon
			:name="computedValue.icon.name"
			:type="computedValue.icon.type || 'filled'"
			:size="computedValue.icon.size || 'small'"
			:state="computedValue.icon.state || 'dark'"
			:effects="false"
		/>
	</Button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Icon, { IconSize, IconState, IconType } from "./../Icon/Icon.vue";
import Button, { ButtonSize, ButtonType } from "./../Button/Button.vue";

type ButtonIconIcon = { name: string; state: IconState; type?: IconType; size?: IconSize };

export type ButtonIconObjectProp = {
	size: ButtonSize;
	type: ButtonType;
	icon: string | ButtonIconIcon;
};

type ButtonIconObjectComputed = {
	size: ButtonSize;
	type: ButtonType;
	icon: ButtonIconIcon;
};

export default defineComponent({
	name: "ButtonIcon",
	components: {
		Button,
		Icon
	},
	props: {
		value: {
			type: [String, Object] as PropType<string | ButtonIconObjectProp>,
			default: "i-generic"
		}
	},
	computed: {
		computedValue() {
			const icon: ButtonIconIcon = {
				name: "i-generic",
				type: "filled",
				size: "x-small",
				state: "dark"
			};

			let outValue: ButtonIconObjectComputed = {
				size: "small",
				type: "primary",
				icon
			};

			const thisValue = this.value;

			if (typeof thisValue === "string") {
				icon.name = thisValue;
			} else if (typeof thisValue === "object") {
				outValue.size = thisValue.size ? thisValue.size : "small";
				outValue.type = thisValue.type ? thisValue.type : "primary";

				if (typeof thisValue.icon === "string") {
					icon.name = thisValue.icon;
				} else {
					outValue = { ...outValue, icon: { ...icon, ...thisValue.icon } };
				}
			}

			return outValue;
		}
	},
	methods: {
		handleClick(e: MouseEvent) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
